import { PERSONA_WORK_STYLE_RATING_LEVELS } from 'modules/admin-panel/pages/results/utils';

export const getPersonaRatingType = (n: number) => {
	if (n >= PERSONA_WORK_STYLE_RATING_LEVELS.extreme.min)
		return PERSONA_WORK_STYLE_RATING_LEVELS.extreme.title;
	if (n >= PERSONA_WORK_STYLE_RATING_LEVELS.high.min)
		return PERSONA_WORK_STYLE_RATING_LEVELS.high.title;
	if (n >= PERSONA_WORK_STYLE_RATING_LEVELS.moderate.min)
		return PERSONA_WORK_STYLE_RATING_LEVELS.moderate.title;
	if (n >= PERSONA_WORK_STYLE_RATING_LEVELS.somewhat.min)
		return PERSONA_WORK_STYLE_RATING_LEVELS.somewhat.title;

	return PERSONA_WORK_STYLE_RATING_LEVELS.notVery.title;
};
